import type React from 'react';
import { memo, useState } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import TextareaAutosize, { type TextareaAutosizeProps } from 'react-textarea-autosize';
import { SWrapper } from '@shared/ui/inputs/TextareaM/styles';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  autosize?: boolean;
  label?: string;
  register?: UseFormRegisterReturn<string>;
  error?: string;
}

export type TextareaMPT = TextareaProps;
export const TextareaM = memo(
  ({
    error,
    placeholder,
    required,
    className,
    value,
    onClick,
    onFocus,
    onBlur,
    ...props
  }: TextareaMPT) => {
    const [isFocusOn, setIsFocusOn] = useState(false);
    return (
      <SWrapper
        $required={required}
        $error={!!error}
        $autosize={props.autosize}
        className={className}
      >
        <Textarea
          value={value}
          placeholder={placeholder}
          onClick={(e) => {
            e.preventDefault();
            onClick && onClick(e);
          }}
          onFocus={(e) => {
            setIsFocusOn(true);
            onFocus && onFocus(e);
          }}
          onBlur={(e) => {
            setIsFocusOn(false);
            onBlur && onBlur(e);
          }}
          {...props}
        />

        {placeholder && !isFocusOn && <div className="placeholder">{placeholder}</div>}
      </SWrapper>
    );
  }
);

const Textarea = memo(({ autosize = false, register, ...props }: TextareaProps) => {
  return autosize ? (
    <TextareaAutosize {...(props as TextareaAutosizeProps)} {...register} />
  ) : (
    <textarea {...props} {...register} />
  );
});
